module.exports = __webpack_public_path__ + "img/demo-home.f7862797.webp";